import(/* webpackMode: "eager" */ "/codebuild/output/src2460931717/src/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["TrackViewItemGAEvent"] */ "/codebuild/output/src2460931717/src/src/service/GA4/TrackViewItemGAEvent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion"] */ "/codebuild/output/src2460931717/src/src/ui/common/Accordion/Accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RatingLink"] */ "/codebuild/output/src2460931717/src/src/ui/common/Links/RatingLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SliderCustomTexts"] */ "/codebuild/output/src2460931717/src/src/ui/common/Slider/SliderCustomTexts.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2460931717/src/src/ui/components/AvailabilityCalendar/AvailabilityCalendar.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2460931717/src/src/ui/components/Map/Map.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2460931717/src/src/ui/components/ReviewsWidget/ReviewsWidget.tsx");
